import type { Content, GroupField } from '@prismicio/client';
import type { Simplify } from '../../../../../../prismicio-types';
import styles from './borrowMoreAdvantages.module.scss';
import { BulletIcons } from '@/assets';
import { consistentAnimationDuration } from '@/utils';

interface BorrowMoreAdvantagesProps {
  advantages: GroupField<
    Simplify<Content.BorrowMoreSliceDefaultPrimaryAdvantagesItem>
  >;
  isVisible: boolean;
}

export const BorrowMoreAdvantages = ({
  advantages,
  isVisible,
}: BorrowMoreAdvantagesProps) => {
  return (
    <ul className={styles.advantagesList}>
      {advantages.map((item, index) => (
        <li
          key={index}
          className={`${styles.advantageItem} ${isVisible ? styles.isVisible : ''}`}
          style={consistentAnimationDuration(1.2, index)}
        >
          <div className={styles.icon}>
            <BulletIcons icon={item.icon} />
          </div>
          <p className={styles.advantageText}>{item.text}</p>
        </li>
      ))}
    </ul>
  );
};
